import {inject, Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import { AppAuthService } from '../_services/app-auth.service';

@Injectable()
export class CurrentOrgInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const appAuthService = inject(AppAuthService);
        const currentOrg = appAuthService.currentOrganization;

        if (!currentOrg) return next.handle(req);

        if (!currentOrg || !currentOrg.name) return next.handle(req);
        const orgId = currentOrg?.id ? currentOrg.id.toString() : null;

        const headers = req.headers.append('x-selected-store', currentOrg.name);

        const modifiedRequest = orgId
            ? req.clone({ headers: headers.append('CurrentOrgId', orgId) })
            : req.clone({ headers });

        return next.handle(modifiedRequest);
    }
}
